export default __webpack_public_path__ + "static/media/TylerHostlerMathis_RESUME.d159df81.pdf";